import script from "./AnalyticsConsent.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsConsent.vue?vue&type=script&setup=true&lang=js"

import "./AnalyticsConsent.vue?vue&type=style&index=0&id=01def7f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01def7f7"]])

export default __exports__